// A dropdown anchored to its button can open past the screen's edge: the phone "+" menu sits on the header's LEFT but is
// anchored `right-0`, so on a phone most of it opened off-screen to the left (owner 2026-10-20, screenshot of the Desk).
// Used as a ref (`ref={keepInView}`): once drawn, the box is shifted back inside the viewport with an 8 px margin, and
// never wider than the screen. Only a translate — its anchoring classes stay as they are for every screen it fits.
export function keepInView(el) {
  if (!el) return
  requestAnimationFrame(() => {
    if (!el.isConnected) return
    el.style.translate = ''
    const m = 8
    const vw = document.documentElement.clientWidth
    if (el.getBoundingClientRect().width > vw - 2 * m) el.style.maxWidth = `${vw - 2 * m}px`
    const r = el.getBoundingClientRect()
    const dx = r.left < m ? m - r.left : r.right > vw - m ? vw - m - r.right : 0
    if (dx) el.style.translate = `${Math.round(dx)}px 0`
  })
}
